import * as React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import groupBy from 'lodash-es/groupBy';
import { PeaksPoint, PeaksPeriod } from '../interfacesPeaks/PeaksJS';

export interface EventTotalsProps {
    pointEvents: Array<PeaksPoint>;
    periodEvents: Array<PeaksPeriod>;
}


export const EventTotals = (props: EventTotalsProps) => {
    const renderEventTypes = (eventTypeGroup): Array<React.ReactNode> => {
        const listItems: Array<React.ReactNode> = [];

        const tooltip = <Tooltip id="DuplicateThresholdWarningTooltip" style={{ zIndex: 2500 }}>
            Events within the duplicate threshold are present in the recording
        </Tooltip>

        for (var property in eventTypeGroup) {
            const group: Array<PeaksPoint & PeaksPeriod> = eventTypeGroup[property];

            const duplicateEvents = group.filter(x => x.withinDuplicateThreshold && !x.confirmedValidDuplicate);

            listItems.push(
                <li key={property} className="list-group-item col-xs-4">
                    <span className="badge badge-info">{group.length}</span>
                    {duplicateEvents.length > 0 ? <OverlayTrigger placement="top" overlay={tooltip}><span className="badge badge-warning"><i className="fas fa-exclamation-triangle"></i></span></OverlayTrigger> : null}
                    {group[0].eventTypeName}
                </li>
            );
        }
        return listItems;
    }

    const groupedPointEvents = groupBy(props.pointEvents, 'eventTypeId');
    const groupedPeriodEvents = groupBy(props.periodEvents, 'eventTypeId');

    const groupedAll = Object.assign({}, groupedPointEvents, groupedPeriodEvents);

    return (
        <>
            <h3 className="text-primary">Total Events</h3>
            <ul className="list-group">
                {renderEventTypes(groupedAll)}
            </ul>
        </>
    );
}
